import React from "react";
import { NavLink } from "react-router-dom";
import { Popover, Button, Menu, Layout, Row, Col } from "antd";
import {
  ProfileText,
  BarWrapper,
  MenuWrapper,
  ProfileInfo,
  SiteName,
  LogoGroup,
} from "./styles";
import { createNewPath } from "../../helpers";
import HistoryAlert from "./HistoryAlert";
import OrganisationLogo from "./logo.png";
import returnEnvironment from "./navbarUtils";

const matchEntityToSelectedTab = {
  dashboards: ["dashboards"],
  scenarios: ["scenarios"],
  data: ["data"],
  "event-planner": ["event-planner"],
};

const LeftCol = ({
  config: {
    data: { siteName },
  },
}) => (
  <Col
    span={6}
    style={{ display: "flex", minHeight: 0, alignItems: "flex-end" }}
  >
    <LogoGroup>
      <img src={OrganisationLogo} alt="OrganisationLogo" />
      <SiteName color={returnEnvironment(window.location.host)}>
        {siteName}
      </SiteName>
    </LogoGroup>
  </Col>
);

const MidCol = ({ navbarLinks = [], routeParams, location }) => {
  const { pathname } = location;
  const selected = matchEntityToSelectedTab[pathname.split("/")[1]];

  return (
    <Col span={12}>
      <MenuWrapper
        mode="horizontal"
        bg={returnEnvironment(window.location.host)}
        color="greyscale.6"
        height="navBarHeight"
        selectedKeys={selected}
      >
        {navbarLinks.map(({ name, icon, path, route }) => (
          <Menu.Item key={route.split("/")[1]}>
            <NavLink to={createNewPath(path, routeParams)}>
              {icon && icon}
              {name}
            </NavLink>
          </Menu.Item>
        ))}
      </MenuWrapper>
    </Col>
  );
};

// div is necessary for easier setting float to right without height issue.
const RightCol = ({
  userProfileMenuOptions = [],
  userProfile: { jobTitle, firstName, lastName },
  currentScenario,
  routeParams,
}) => (
  <Col span={6}>
    <div>
      <ProfileInfo color="greyscale.6" mr={2}>
        <ProfileText fontSize={4} fontWeight={600}>
          {`${firstName || ""} ${lastName || ""}`}
        </ProfileText>
        <ProfileText fontSize={2}>{jobTitle}</ProfileText>
      </ProfileInfo>
      <Popover
        placement="bottomRight"
        trigger="click"
        content={
          <Menu>
            {userProfileMenuOptions.map(({ name, path, useAnchor, route }) => (
              <Menu.Item key={route}>
                {useAnchor ? (
                  <a href={path}>{name}</a>
                ) : (
                  <NavLink to={path}>{name}</NavLink>
                )}
              </Menu.Item>
            ))}
          </Menu>
        }
        overlayClassName="DCRP-navbar-popover"
      >
        <Button shape="circle" icon="user" size="large" />
      </Popover>
      <HistoryAlert
        routeParams={routeParams}
        currentScenario={currentScenario}
      />
    </div>
  </Col>
);

const NavBar = (props) => {
  return (
    <BarWrapper
      bg={returnEnvironment(window.location.host)}
      height="navBarHeight"
    >
      <Layout.Header>
        <Row style={{ display: "flex" }}>
          <LeftCol {...props} />
          <MidCol {...props} />
          <RightCol {...props} />
        </Row>
      </Layout.Header>
    </BarWrapper>
  );
};

export default NavBar;
